import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { getAssigneesFromImportRequests } from 'services/import-requests'
import { ImportRequestQueryKeys } from 'services/import-requests/queryKeys'
import type { GetImportRequestFilterAssigneesResponse } from 'services/import-requests/types'
import type { ApiErrorResponse } from 'services/types'

export const useGetAssigneesFromImportRequests = (
  options?: Omit<UseQueryOptions<GetImportRequestFilterAssigneesResponse, ApiErrorResponse>, 'queryKey'>
) =>
  useQuery<GetImportRequestFilterAssigneesResponse, ApiErrorResponse>({
    queryKey: ImportRequestQueryKeys.FilterAssignees(),
    queryFn: ({ signal }) => getAssigneesFromImportRequests({ signal }),
    ...options
  })
